// src/api/service/admin/admin_orders.service.ts
import { env } from "../../../config/env";
import { apiClient } from "../../config";
import { AdminOrdersResponse } from "../../interface/admin.interface";

class AdminOrdersService {
    /**
     * Liste des commandes (paginée)
     */
    async getOrders(params?: {
        page?: number;
        status?: string;
        payment_status?: string;
        date_from?: string;
        date_to?: string;
        search?: string;
    }): Promise<AdminOrdersResponse> {
        const response = await apiClient.get<AdminOrdersResponse>(
            env.ADMIN_ORDERS.BASE,
            { params }
        );
        return response.data;
    }

    async getOrder(id: string) {
        const response = await apiClient.get(env.ADMIN_ORDERS.SHOW(id));
        return response.data;
    }

    async updateStatus(id: string, status: string) {
        const response = await apiClient.put(env.ADMIN_ORDERS.UPDATE_STATUS(id), { status });
        return response.data;
    }

    async deleteOrder(id: string) {
        const response = await apiClient.delete(env.ADMIN_ORDERS.DELETE(id));
        return response.data;
    }

    async sendWhatsApp(id: string) {
        const response = await apiClient.post(env.ADMIN_ORDERS.SEND_WHATSAPP(id));
        return response.data;
    }
}

export const adminOrdersService = new AdminOrdersService();